<template>
	<div class="menu" v-if="!$attrs.disable" v-on:click="isMenuActive =! isMenuActive" :class="{'isActive': isMenuActive}">
		<div v-if="audioData.duration" class="mini--seekbar" :style="{ width: Math.floor(($store.state.seekTime / audioData.duration) * 100) +'%'}"></div>
		<!-- playing -->
		<div class="playing--wrapper">
			<div class="photo">
				<div @click="$router.push({ name: 'ProfileCreator', params: { id: audioData.uid }}), isMenuActive =! isMenuActive" :style="{ backgroundImage: `linear-gradient(140deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)), url(${audioData.cover})` }"
				class="img"
				></div>
			</div>
			<div v-on:click="isMenuActive = isMenuActive" class="listening--wrapper" :class="{'isActive': isMenuActive}">
				<div class="title" v-if="!$store.state.isLoading"><marquee>{{ audioData.title }}</marquee></div><div class="title" v-else>Buffering...</div>
				<div class="creator" v-if="!$store.state.isLoading">{{ audioData.creator }}</div>
				<div class="creator" v-else>Buffering...</div>
			</div>
			<div class="playbtn--wrapper">
				<!-- iconPlay&Back -->
				<i v-if="isMenuActive = isMenuActive" class="material-icons">keyboard_arrow_down</i>
				<div v-else v-on:click="isMenuActive =! isMenuActive">
					<div style="display: flex;" v-if="$store.state.isStoping" @click="play()"><i class="material-icons">play_arrow</i></div>
					<div style="display: flex;" v-else-if="$store.state.isPlaying == null" @click="play()"><i class="material-icons">play_arrow</i></div>
					<div style="display: flex;" v-else @click="pause()"><i class="material-icons">pause</i></div>
				</div>
			</div>
		</div>
		<!-- menubar -->
		<div v-if="isMenuActive = isMenuActive" class="controller--wrapper">
			<!-- controller -->
			<div class="player--wrapper" v-on:click="isMenuActive =! isMenuActive">
				<transition name="slide-fade" mode="out-in">
					<div class="replay" @click="seekReplay()" :class="($store.state.mode === 'dark') ? 'btn-wrapper-dark' : 'false'">
						<i class="material-icons">replay_10</i>
					</div>
				</transition>
				<transition name="slide-fade" mode="out-in">
					<div
						class="play"
						:class="($store.state.mode === 'dark') ? 'btn-wrapper-dark' : 'false'"
						v-if="$store.state.isStoping"
						@click="play()">
						<i class="material-icons">play_arrow</i>
					</div>
					<div class="play" :class="($store.state.mode === 'dark') ? 'btn-wrapper-dark' : 'false'" v-else-if="$store.state.isPlaying == null" @click="play()"><i class="material-icons">play_arrow</i></div>
					<div class="play" :class="($store.state.mode === 'dark') ? 'btn-wrapper-dark' : 'false'" v-else @click="pause()"><i class="material-icons">pause</i></div>
				</transition>
				<transition name="slide-fade" mode="out-in">
					<div class="replay" @click="seekFoward()" :class="($store.state.mode === 'dark') ? 'btn-wrapper-dark' : 'false'">
						<i class="material-icons">forward_10</i>
					</div>
				</transition>
			</div>
			<!-- seekbar -->
			<div class="duration--wrapper">
				<span v-if="!isNaN($store.state.seekTime)" class="current-time">{{ timeConvert($store.state.seekTime) }}</span>
				<span v-else class="current-time">{{ timeConvert(0) }}</span>
				<span v-if="audioData.duration" class="total-time">{{ timeConvert(audioData.duration) }}</span>
			</div>
			<div class="seekbar--wrapper" v-on:click="isMenuActive =! isMenuActive">
				<vue-slider
					v-if="audioData.duration"
					@click.native="seekChange()"
					@drag-end="seekChange()"
					ref="seekSlider"
					:lazy="true"
					:max="audioData.duration"
					:value="$store.state.seekTime"
					:tooltip-formatter="val => timeConvert(val)">
				</vue-slider>
			</div>
		</div>
	</div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/material.css'
import db from '@/db'
export default {
	name: 'menuBar',
	components: {
		VueSlider
	},
	data() {
		return {
			pict: "https://firebasestorage.googleapis.com/v0/b/jitube.appspot.com/o/covers%2FoskMblXhCVNaIc5ytdImwdMZQu13%2Fcover.jpg?alt=media",
			audioData: null,
			isMenuActive: false,
			currentTime: 0,
			durationTime: 100,
		}
	},
	computed: {
		isPlaying () {
			return this.$store.state.isPlaying
		},
	},
	watch: {
		isPlaying (audioUrl) {
			let _this = this
			db.collection('episodes').where("audio","==",audioUrl).get().then((snapshot) => {
				snapshot.forEach(function(doc) {
					db.collection('creator').doc(doc.data().uid).get().then(function(creator) {	
						_this.audioData = {
							audio: doc.data().audio,
							created_at: doc.data().created_at,
							duration: doc.data().duration,
							title: doc.data().title,
							listener: doc.data().listener,
							uid: doc.data().uid,
							creator: creator.data().podcastName,
							cover: creator.data().cover,
							verified: creator.data().verified
						};
					})
				})
			})
		},
	},
	methods: {
		play: function() {
			this.$store.commit('playSound', this.audioData.audio)
		},
		pause: function() {
			this.$store.commit('pauseSound', this.audioData.audio)
		},
		seekChange: function() {
			this.$store.commit('seekChange', this.$refs.seekSlider.getValue())
		},
		seekFoward: function() {
			this.$store.commit('seekChange', this.$refs.seekSlider.getValue() + 10)
		},
		seekReplay: function() {
			this.$store.commit('seekChange', this.$refs.seekSlider.getValue() - 10)
		}
	},
};
</script>

<style lang="scss">
@import '~vue-slider-component/lib/theme/material.scss';
$base-color: #1b7b46;
$inner-color: #caefe2;
.menu.light {
	background-color: rgb(255,255,255);
	border-top: .10rem solid rgba($inner-color, 1);
}
.menu.dark {
	background-color: rgb(0,0,0);
}
/*menubar*/
.menu {
	z-index: 100;
	width: 100%;
	bottom: 0;
	left: 0;
	height: 55px;
	position: fixed;
	border-top: .10rem solid rgba($inner-color, .1);
	transition: .35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
	&.isActive {
		height: 12rem;
		transition: .25s cubic-bezier(0, 0, 0.2, 1);
	}
	.mini--seekbar{
		top: -.10rem;
		height: .10rem;
		background-color: $base-color;
		position: absolute;
		transition: cubic-bezier(0.55, 0.09, 0.68, 0.53) .25s;
	}

	.playing--wrapper {
		display: flex;
		align-items: center;
		padding: .4rem 1.5rem;
		.photo {
			width: 40px;
			height: 40px;
			border-radius: 12px;
			.img {
				width: inherit;
				height: inherit;
				position: inherit;
				background-size: cover;
				background-position: center;
				border-radius: inherit;
				position: inherit;
			}
		}
		.listening--wrapper {
			width: 100%;
			padding: 0 12px;
			.title {
				font-size: 12px;
				letter-spacing: .015rem;
				-webkit-mask-image:linear-gradient(90deg, transparent, rgba(0,0,0,1) 20% 70%,transparent);
			}
			.creator {
				font-size: 10px;
				letter-spacing: .015rem;
				opacity: 0.7;
			}
		}
	}
	.controller--wrapper {
		width: 100%;
		transition: 0.25s ease-in-out;
		.player--wrapper {
			display: flex;
			justify-content: space-around;
			align-items: center;
			padding: 1rem 6rem;
			.btn-wrapper-dark {
				background-color: rgba($base-color, .2);
			}
			.replay {
				display: flex;
				padding: .5rem;
				background-color: rgba($base-color, .1);
				outline: 0;
				border-radius: 50%;
				text-decoration: none;
				transition: 0.25s ease-in-out;
				i {
					font-size: 26px;
				}
				&:active {
					opacity: 0.75;
					transform: scale(0.90);
				}
			}
			.play {
				display: flex;
				padding: .5rem;
				background-color: rgba($base-color, .1);
				outline: 0;
				border-radius: 50%;
				text-decoration: none;
				transition: 0.25s ease-in-out;
				i {
					font-size: 44px;
					color: $base-color;
				}
				&:active {
					opacity: 0.75;
					transform: scale(0.90);
				}
			}
		}
		.duration--wrapper {
			display: flex;
			padding: 0 2rem;
			justify-content: space-between;
			.current-time,
			.total-time {
				font-size: 0.7rem;
			}
		}
		.seekbar--wrapper {
			padding: 0 2rem;
			margin: 0 auto;
			.el-slider__bar {
				background-color: $base-color;
			}
			.el-slider__button {
				border: 2px solid $base-color;
			}
			.vue-slider-dot-tooltip-text {
				width: 70px;
				height: 70px;
				font-size: 14px;
			}
			.vue-slider-dot-tooltip-top {
				top: -30px;
			}
			.vue-slider-dot-handle::after {
				background-color: rgba($base-color, .3);
			}
			.vue-slider-dot-tooltip,
			.vue-slider-dot-tooltip-top {
				pointer-events: none;
			}
			.vue-slider-process,
			.vue-slider-dot-handle,
			.vue-slider-dot-tooltip-inner,
			.vue-slider-dot-tooltip-inner-top {
				background-color: $base-color;
			}
			.vue-slider-rail {
				background-color: rgba($inner-color, .1); 
			}
		}
	}
}
</style>